import { createSlice } from "@reduxjs/toolkit";

const initialCashFlowSubscriptionState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  cashFlowSubscriptionForEdit: undefined,
  lastError: null,
  message: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const cashFlowSubscriptionSlice = createSlice({
  name: "cashFlowSubscriptions",
  initialState: initialCashFlowSubscriptionState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error.clientMessage;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.message = null;

      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      state.message = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    // getCashFlowSubscriptionById
    cashFlowSubscriptionFetched: (state, action) => {
      state.actionsLoading = false;
      state.cashFlowSubscriptionForEdit =
        action.payload.cashFlowSubscriptionForEdit;
      state.floorPlans = action.payload.cashFlowSubscriptionForEdit.floorPlans;
      state.error = null;
    },
    // getCashFlowSubscriptionChart
    cashFlowSubscriptionChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.cashFlowSubscriptionChart =
        action.payload.cashFlowSubscriptionChart;
      state.error = null;
    },
    // getCashFlowSubscriptionChart
    cashFlowSubscriptionHourlyChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.cashFlowSubscriptionChartHour =
        action.payload.cashFlowSubscriptionChartHour;
      state.error = null;
    },
    // getCashFlowSubscriptionChart
    cashFlowSubscriptionHourlyZoneChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.cashFlowSubscriptionChartHourZone =
        action.payload.cashFlowSubscriptionChartHourZone;
      state.error = null;
    },
    // get list data
    cashFlowSubscriptionsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.cashFlowSubscriptionForEdit = undefined;
      state.floorPlans = undefined;
      state.cashFlowSubscriptionChart = undefined;
      state.cashFlowSubscriptionChartHour = undefined;
      state.cashFlowSubscriptionChartHourZone = undefined;
    },
    // createCashFlowSubscription
    cashFlowSubscriptionCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.message = action.payload.msgResponse;
    },
    // updateCashFlowSubscription
    cashFlowSubscriptionUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.message = action.payload.msgResponse;
    },
    // cashFlowSubscriptionDeleted
    cashFlowSubscriptionDeleted: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
      state.actionsLoading = false;
    },
    setMessage: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
    },
    floorPlanDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.floorPlans = state.floorPlans.filter(
        (item) => item.id !== action.payload.id
      );
    },
    floorPlanUpdated: (state, action) => {
      const { id, floorPlan } = action.payload;
      state.error = null;
      state.actionsLoading = false;
      state.floorPlans = state.floorPlans.map((data) => {
        if (data.id === id) {
          return floorPlan;
        }

        return data;
      });
    },
  },
});
